// src/components/Menu/Column.jsx
import React, { useRef } from "react";

const actionBtnStyle = {
  padding: "4px 8px",
  borderRadius: 6,
  border: "1px solid #cbd5e1",
  background: "#f8fafc",
  fontSize: 11,
  cursor: "pointer",
};

const Column = ({
  title,
  children,
  rightBorder = true,
  onImport, // optional: async (file) => ...
  onExport, // optional: () => ...
  onDownloadTemplate, // optional: () => ...
  sortValue,
  sortOptions,
  onSortChange,
  expanded,
  onToggleExpand,
}) => {
  const fileInputRef = useRef(null);

  const triggerImport = () => {
    if (!onImport) return;
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !onImport) return;

    await onImport(file);

    // allow re-selecting same file later
    e.target.value = "";
  };

  return (
    <section
      style={{
        flex: 1,
        padding: 16,
        borderRight: rightBorder ? "1px solid #eee" : "none",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {title && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 12,
            gap: 8,
          }}
        >
          <h4 style={{ marginTop: 0, marginBottom: 0, opacity: 0.7 }}>
            {title}
          </h4>

          <div
            style={{
              display: "flex",
              gap: 6,
              flexWrap: "wrap",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            {Array.isArray(sortOptions) && sortOptions.length > 0 && (
              <label className="menu-manager-sort">
                <span>Sort</span>
                <select
                  value={sortValue || "default"}
                  onChange={(e) => onSortChange?.(e.target.value)}
                  aria-label={`Sort ${title || "list"}`}
                >
                  {sortOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </label>
            )}
            {onDownloadTemplate && (
              <button
                type="button"
                style={actionBtnStyle}
                title="Download a blank spreadsheet with the columns required for import"
                onClick={onDownloadTemplate}
              >
                Template
              </button>
            )}
            {onImport && (
              <>
                <button
                  type="button"
                  style={actionBtnStyle}
                  onClick={triggerImport}
                >
                  Import
                </button>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".json,.csv,.xlsx,.xls"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </>
            )}
            {onExport && (
              <button
                type="button"
                style={actionBtnStyle}
                onClick={onExport}
              >
                Export
              </button>
            )}
            {onToggleExpand && (
              <button
                type="button"
                style={actionBtnStyle}
                title={
                  expanded
                    ? "Show categories and subcategories again"
                    : "Give this list the full width"
                }
                onClick={onToggleExpand}
              >
                {expanded ? "Collapse" : "Expand"}
              </button>
            )}
          </div>
        </div>
      )}

      {children}
    </section>
  );
};

export default Column;
